import { FC, memo } from 'react';
import { useTranslator } from '@picsart/rc/services/localization';
import { Spacings, Texts, Typography } from '@picsart/cascade';
import { Text, TypographyHorizontalAlign } from '@picsart/text';
import { Slider, SliderTypes } from '@picsart/slider';
import View from '@picsart/view/View';
import classNames from 'classnames';

import useStyles from '../styles';
import testIds from '../testIds';

type WatermarkRotateProps = {
  rotateAngle: number;
  disabled: boolean;
  handleChange: (value: number) => void;
}

const WatermarkRotate: FC<WatermarkRotateProps> = ({ rotateAngle, disabled, handleChange }) => {
  const translate = useTranslator();
  const classes = useStyles();

  return (
    <View gap={Spacings.s8} flexDirection="column" marginBlock={Spacings.s16}>
      <Text
        className={classNames({
          [classes.disabledState]: disabled,
        })}
        size={Typography.t4}
        color={Texts.base}
        align={TypographyHorizontalAlign.Left}
      >
        {translate('Rotate')}
      </Text>
      <View>
        <Slider
          dataTestId={testIds.rotate}
          type={SliderTypes.Centered}
          disabled={disabled}
          step={5}
          marks={1}
          min={0}
          max={360}
          value={rotateAngle}
          onChange={value => handleChange(value as number)}
        />
        <View
          className={classNames({
            [classes.disabledState]: disabled,
          })}
          marginInlineStart={Spacings.s12}
          marginBlockStart={Spacings.s2}
        >
          <Text size={Typography.t4} color={Texts.base} align={TypographyHorizontalAlign.Center}>
            {rotateAngle}
            °
          </Text>
        </View>
      </View>
    </View>
  );
};

export default memo(WatermarkRotate);
